import { useState } from "react";
import { Menu, X } from "lucide-react";
import { siteContent } from "@/data/siteContent";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { brand, navigation } = siteContent;
  const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";

  return (
    <header className="site-header" data-testid="site-header">
      <div className="site-container header-inner">
        <a className="text-brand" href="/" aria-label={`${brand.name} home`} data-testid="header-brand-link">
          <span className="header-symbol-wrap" aria-hidden="true">
            <img
              className="header-symbol"
              src={brand.assets.compactSymbol}
              alt=""
              width="42"
              height="41"
              decoding="async"
              fetchPriority="high"
              data-testid="header-brand-symbol"
            />
          </span>
          <span className="brand-copy">
            <span className="brand-name" data-testid="header-brand-name">{brand.name}</span>
            <span className="brand-line" data-testid="header-brand-mission">{brand.mission}</span>
          </span>
        </a>

        <nav className="desktop-nav" aria-label="Primary navigation" data-testid="desktop-primary-navigation">
          {navigation.items.map((item) => (
            <a
              key={item.label}
              href={item.destination}
              className={item.emphasis ? "nav-start" : undefined}
              aria-current={(item.destination === "/" && currentPath === "/") || (item.destination === "/start-here" && currentPath === "/start-here") ? "page" : undefined}
              data-testid={`desktop-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`}
            >
              {item.label}
            </a>
          ))}
          <a className="nav-member" href={navigation.memberLogin.destination} data-testid="desktop-member-login-link">
            {navigation.memberLogin.label}
          </a>
        </nav>

        <button
          className="mobile-menu-button"
          type="button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((value) => !value)}
          data-testid="mobile-menu-toggle-button"
        >
          {open ? <X size={21} aria-hidden="true" /> : <Menu size={21} aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-navigation" className="mobile-nav" aria-label="Mobile navigation" data-testid="mobile-primary-navigation">
          {navigation.items.map((item) => (
            <a
              key={item.label}
              href={item.destination}
              className={item.emphasis ? "nav-start" : undefined}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`}
            >
              {item.label}
            </a>
          ))}
          <a href={navigation.memberLogin.destination} onClick={() => setOpen(false)} data-testid="mobile-member-login-link">
            {navigation.memberLogin.label}
          </a>
        </nav>
      )}
    </header>
  );
};